<div class="cont-input {clases}">
      <label class="label-input {labelFloated ? 'floated' : ''}" for={inputId}>
            {label}
      </label>
      <input
            type="text"
            id={inputId}
            name="fecha"
            bind:value
            maxlength="10"
            placeholder={labelFloated ? "DD/MM/YYYY" : ""}
            class="input {errorClass}"
            on:input={cambio}
            on:focus={() => (isFocused = true)}
            on:blur={() => (isFocused = false)}
            on:keydown={manejarKeydown}
      />
      <div class="cont-error">
            <span class="supporting-text">
                  {#if !allValid}
                        {errorMSG} Formato de fecha no válido. Use DD/MM/YYYY.
                  {/if}
            </span>
      </div>
</div>
{fechaH}
<br />

<script>
      import { onMount } from "svelte";

      export let label = "Fecha";
      export let errorMSG = "Error:";
      export let value = "";
      export let fechaJS;
      export let fechaH;
      export let clases = "";

      //   let dia = 0;
      //   let mes = 0;
      //   let year = 0;
      let isFocused = false;
      let allValid = true;
      const inputId = Math.random().toString(36).substring(2, 15);

      // Determinar si el label debe estar flotante
      $: labelFloated = isFocused || value.length > 0;
      $: errorClass = allValid ? "" : "error-input-material";

      onMount(() => {
            cambio();
      });

      function cambio() {
            // Formatear la fecha al escribir
            if (value.length === 2 || value.length === 5) {
                  value += "/"; // Agregar '/' automáticamente
            }
            let largoTotal = value.length;
            console.log("CAMBIO:" + value + " -> " + largoTotal);

            // Validar si el largo es 10 e intentar crear un objeto Date
            let formatValid = false;
            if (value.length === 10) {
                  const [day, month, year] = value.split("/");

                  // Validar si es una fecha válida
                  if (
                        isFinite(day) &&
                        isFinite(month) &&
                        isFinite(year) &&
                        day > 0 &&
                        day <= 31 &&
                        month > 0 &&
                        month <= 12 &&
                        year.length === 4
                  ) {
                        fechaJS = new Date(`${year}-${month}-${day}`);
                        fechaH = formatearFechaEspanol(fechaJS);
                        formatValid = true;
                  }

                  // REAL VALIDACION:

                  if (largoTotal === 10 && formatValid) {
                        let largoYear = year.length;
                        let largoMonth = month.length;
                        let largoDay = day.length;

                        console.log("LARGO TOTAL:" + largoTotal);
                        console.log("FORMATO VALIDO:" + formatValid);
                        console.log("LARGO DAY:" + largoDay);
                        console.log("LARGO MONTH:" + largoMonth);
                        console.log("LARGO YEAR:" + largoYear);
                        if (largoDay == 2 && largoMonth == 2 && largoYear == 4) {
                              allValid = true;
                        } else {
                              allValid = false;
                        }
                  } else {
                        allValid = false;
                        errorMSG = "Error: Formato de fecha inválido:";
                  }
            } else {
                  allValid = false;
            }

            console.log("ALL VALID : " + allValid);
            console.log("-------------------");
      }

      function verificarDia(diaRecibido) {
            let diaValido = false;

            if (isNumeric(diaRecibido)) {
                  diaRecibido = parseInt(diaRecibido);

                  if (diaRecibido > 0 && diaRecibido <= 31) {
                        diaValido = true;
                  }
            } else {
                  diaValido = false;
                  errorMSG = "El dia debe ser un numero";
            }

            return diaValido;
      }
      function manejarKeydown(event) {
            // Detectar si la tecla presionada es 'Backspace'
            if (event.key === "Backspace") {
                  // Evitar el comportamiento por defecto
                  event.preventDefault();

                  // Verificar si el último carácter es '/'
                  if (value.endsWith("/")) {
                        console.log("TERMINA EN SLASH");
                        value = value.slice(0, -2);
                  } else {
                        console.log("NO TERMINA EN SLASH");
                        value = value.slice(0, -1);
                  }

                  cambio();
            }
      }

      function formatearFechaEspanol(fecha) {
            // Validar que el parámetro sea un objeto Date válido
            if (!(fecha instanceof Date) || isNaN(fecha)) {
                  console.error("Fecha inválida:", fecha);
                  return "Fecha inválida";
            }

            // Opciones de formato en español
            const opciones = {
                  weekday: "short", // Día abreviado (Ej: "lun.")
                  day: "2-digit", // Día con dos dígitos
                  month: "short", // Mes abreviado (Ej: "may.")
                  year: "numeric", // Año completo
            };

            // Usar Intl.DateTimeFormat para formatear la fecha
            let fechaFormateada = new Intl.DateTimeFormat("es-ES", opciones).format(fecha);

            return fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
      }
      function isNumeric(value) {
            return !isNaN(value) && value.trim() !== "";
      }
</script>

<style>
      .cont-input {
            display: flex;
            flex-direction: column;
            position: relative;
            margin: 20px 0;
            font-family: "Roboto", sans-serif;
            padding-left: 25px;
            padding-right: 25px;
      }

      .label-input {
            position: absolute;
            left: 40px;
            top: 16px;
            font-size: 16px;
            color: #5f5f5f;
            transition:
                  top 0.2s ease,
                  font-size 0.2s ease;
            cursor: text;
      }

      .label-input.floated {
            top: -10px;
            left: 50px;
            font-size: 14px;
            color: #7f56da;
            background-color: white;
            border-radius: 6px;
      }

      .input {
            padding: 16px;
            border: 1px solid #c3c3c3;
            border-radius: 50px;
            font-size: 16px;
            outline: none;
            transition: border-color 0.2s;
      }

      .input:focus {
            border-color: #7f56da;
      }

      .cont-error {
            margin-top: 8px;
            padding-left: 25px;
      }

      .supporting-text {
            margin-top: 4px;
            font-size: 12px;
            color: red;
      }

      .error-input-material {
            border: solid 2px red !important;
      }
</style>
